
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import VueUeditorWrap from 'vue-ueditor-wrap';

@Component({
  name: 'uEditor',
  components: {
    VueUeditorWrap,
  },
})

export default class uEditor extends Vue {
  @Prop({
    type: String,
    default: false,
  }) inputContent!: string;

  private content = this.inputContent;

  @Watch('inputContent', { immediate: true })
  getContent(v: string) {
    console.log(v);
    // if (v) {
    //   this.content = v;
    //   console.log(this.content)
    // } else if (this.inputContent.length < 0) {
    //   this.content = "";
    //   console.log(this.content)
    // }
    // this.content = this.inputContent;
    this.content = v;
  }

  private config: any = {
    UEDITOR_HOME_URL: '/UEditor/',
    serverUrl: 'https://resource.coding4fun.com.cn/coding4fun-resource/ueditor/handler',
    toolbars: [
      ['fullscreen', 'source', '|', 'bold', 'italic', 'underline', 'forecolor', 'fontfamily',
        'fontsize', '|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
        'simpleupload', 'insertimage', 'inserttable', 'gapfilling', 'preview',
      ],
    ],
    initialFrameHeight: 340,
    zIndex: 999999,
    focus: true,
    autoClearinitialContent: false,
    enterTag: 'br',
    enableAutoSave: false,
  };

  ready(instance: any) {
    this.$emit('ready', instance);
  }
}
